import React, { useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ProgressProvider } from "./context/ProgressContext";
import Navbar from "./components/Navbar";
import WelcomeModal from "./components/WelcomeModal";
import LandingPage from "./pages/LandingPage";
import AuthPage from "./pages/AuthPage";
import CoursePage from "./pages/CoursePage";
import UnlockPage from "./pages/UnlockPage";
import AdminPage from "./pages/AdminPage";

function MainApp() {
  const [showWelcome, setShowWelcome] = useState(
    () => !localStorage.getItem("sl_welcomed"),
  );
  return (
    <>
      {showWelcome && <WelcomeModal onClose={() => setShowWelcome(false)} />}
      <Navbar />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/course" element={<CoursePage />} />
        <Route path="/unlock" element={<UnlockPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

function AppRouter() {
  const location = useLocation();
  // Admin is completely isolated — no Navbar, no ribbon, no auth context
  if (
    location.pathname === "/admin" ||
    location.pathname.startsWith("/admin/")
  ) {
    return (
      <Routes>
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/admin/*" element={<AdminPage />} />
      </Routes>
    );
  }
  return (
    <AuthProvider>
      <ProgressProvider>
        <MainApp />
      </ProgressProvider>
    </AuthProvider>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRouter />
    </BrowserRouter>
  );
}
